/* eslint-disable max-len */
module.exports = {
  // =================== KnowledgeBase ===================
  knowledgebase: {
    pagetitle: "БАЗА ЗНАНИЙ",
    vmc: {
      title: "Визуально-измерительный контроль сварных швов",
      backgroundimg: "/img/knowledgebase/vmc-background-01.jpg",
      meta: "Дата публикации: 25.08.2021",
      content: `
        <p class="uk-text-lead rz-txt-light">Первая стадия любого неразрушающего контроля - это визуальный и измерительный контроль (сокращенно - ВИК)</p>
        <p>Независимо от группы технических устройств (назначения изделий), ВИК применяется всегда и выполняется в объеме 100% как для основного металла, так и для всех сварных швов конструкции.</p>
        <p>К радиографическому или ультразвуковому контролю приступают строго только после проведения ВИК. <span class="rz-txt-light">ВИК - это первый рубеж защиты от явного брака.</span></p>
        <p>
          <span class="uk-text-bold">Процесс визуального контроля состоит из двух этапов:</span>
          <ul class="uk-list uk-list-bullet">
            <li><span class="uk-text-bold">Визуального осмотра</span> невооружённым взглядом либо с применением увеличительных приборов;</li>
            <li><span class="uk-text-bold">Измерения</span> конкретных геометрических параметров при помощи специальных инструментов.</li>
          </ul>
          Эти операции выполняются параллельно либо поочерёдно.<br>
          Визуальный и измерительный контроль сварного соединения нельзя сводить к простому осмотру.<br>
          Это довольно жёсткая проверка геометрии, качества обработки поверхности и прочих параметров по критериям, прописанным в инструкции.
        </p>
        <p>Визуальный контроль способен выявить только поверхностные дефекты. В этом его основной недостаток. Но главные преимущества ВИК - это простота проведения, возможность выполнения в полевых условиях, высокая скорость, недорогое оборудование.</p>
        <div class="uk-flex uk-flex-center"><div class="uk-inline">
          <img class="uk-border-rounded rz-box-shadow-small" data-src="/img/knowledgebase/vmc-01.jpg" width="800" height="450" alt="" uk-img="">
          <div class="uk-overlay uk-light uk-position-bottom"><p class="txt-white txt-stroke-blue-shadow">Измерение высоты усиления сварного шва</p></div>
        </div></div>
      `
    }

  }
};
/* eslint-enable max-len */
